import { Layout, Page, usePath } from "@fdoh/health-ui-react";
import { useData } from "../../hooks";
import AbandonmentForm from "../Components/AbandonmentForm";
import { AbandonmentInput } from "../Components/AbandonmentForm.types";
import ApplicationDetailsPage from "../Components/Home/ApplicationDetails";
import { useHistory, useLocation } from "react-router-dom";

// TODO: Add error handling



const EditAbandonmentPage = () => {
    const path = usePath();
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const applicationId = JSON.parse(searchParams.get("applicationId") || '{}');
    const inspectionId = JSON.parse(searchParams.get("inspectionId") || '{}');
    const data = useData<AbandonmentInput>(path.current) ;
  return data && applicationId ? (
      <Page.Container>
          <ApplicationDetailsPage id={applicationId}></ApplicationDetailsPage>      
      <Page.Body>
        <Layout.Container>
                  <AbandonmentForm
                      id="editAbandonmentForm"
                      title="Abandonment Inspection"
            action="post"
            applicationId={applicationId ? applicationId : 0}
            applicationInspectionId={inspectionId ? inspectionId : 0}
            returnPath={`/inspectionDetails/${inspectionId}`}
            values={data}
          />
        </Layout.Container>
      </Page.Body>
    </Page.Container>
  ): <Page.Container>
  <Page.Header preTitle="Private Provider Inspection" title="Welcome" />
  <Page.Body>
      <Layout.Container>
          <div className="row row-dec row-cards">
              <div className="col-lg-12">
               
              </div>
          </div>
      </Layout.Container>
  </Page.Body>
</Page.Container>;
};

export default EditAbandonmentPage;